export default {
  namespaced: true,

  state: {
    updated: false,
    groupUpdated: false,
    classUpdated: false,
    studentsUpdated: [],
    levelUpEvent: false,
    deleteEvent: false,
    listReload: false
  },

  getters: {
    updated(state) {
      return state.updated;
    },
    groupUpdated(state) {
      return state.groupUpdated;
    },
    classUpdated(state) {
      return state.classUpdated;
    },
    studentsUpdated(state) {
      return state.studentsUpdated;
    },
    levelUpEvent(state) {
      return state.levelUpEvent;
    },
    deleteEvent(state) {
      return state.deleteEvent;
    },
    listReload(state) {
      return state.listReload;
    }
  },

  mutations: {
    SET_UPDATED(state, value) {
      state.updated = value;
    },
    SET_GROUP_UPDATED(state, value) {
      state.groupUpdated = value;
    },
    SET_CLASS_UPDATED(state, value) {
      state.classUpdated = value;
    },
    SET_STUDENTS_UPDATED(state, value) {
      state.studentsUpdated = value;
    },
    SET_LEVEL_UP_EVENT(state, value) {
      state.levelUpEvent = value;
    },
    SET_DELETE_EVENT(state, value) {
      state.deleteEvent = value;
    },
    SET_LIST_RELOAD(state, value) {
      state.listReload = value;
    }
  },

  actions: {
    studentUpdated({ dispatch, commit }) {
      commit('SET_UPDATED', true);
    },

    studentNotUpdated({ dispatch, commit }) {
      commit('SET_UPDATED', false);
    },
    groupUpdate({ commit }, value) {
      commit('SET_GROUP_UPDATED', value);
    },
    classUpdate({ commit }, value) {
      commit('SET_CLASS_UPDATED', value);
    },
    studentsUpdate({ commit }, value) {
      commit('SET_STUDENTS_UPDATED', value);
    },
    levelUpTrigger({ commit }, value) {
      commit('SET_LEVEL_UP_EVENT', value);
    },
    deleteTrigger({ commit }, value) {
      commit('SET_DELETE_EVENT', value);
    },
    listReloadTrigger({ commit }, value) {
      commit('SET_LIST_RELOAD', value);
    }
  }
};
